$(function () {
  $(".details-accordion > .accordion-item").click(function () {
    //$(this).siblings(".accordion-item").removeClass("active");
    $(this).toggleClass("active");
  });
});
